export default __webpack_public_path__ + "static/media/bariol_thin-webfont.dd37f484.woff";